module.exports = __webpack_public_path__ + "c1034239929f4651cc17d09ed3a28c69.ttf";